<a
  *transloco="let t; read: 'social-share-buttons'"
  id="trkWhatsappShareButton"
  class="btn-share btn-share-whatsapp"
  href="javascript:void(0)"
  [attr.aria-label]="t('whatsapp_share')"
  (click)="share()">
  <accredible-icon [icon]="'whatsapp'"> </accredible-icon>
</a>
